import script from "./ViewingCardAppointmentDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewingCardAppointmentDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ViewingCardAppointmentDetails.vue?vue&type=style&index=0&id=2e06a23c&lang=postcss&scoped=true"

import exportComponent from "/var/www/keyvue-customer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e06a23c"]])

export default __exports__